import { Cast } from '@/modules/casts/classes'
import { CastAudioTracksDict, MIXER_CASTER_TRACKS_LIMIT, MixerTrackLabel, defaultMixerTrackLabel } from '../types'
import { HasAudioTracks } from '@/modules/classBuilder/mixins/hasAudioTracks'
import { CastType } from '@/types/casts'
import { TRACK_PREFIX_CASTER, LABEL_TO_MIXER_TRACK_MAP } from '@/types/streams'

export const getAudioTracksForCount = (count: number) => {
  const countStrict = Math.min(Math.max(count, 1), MIXER_CASTER_TRACKS_LIMIT)
  const tracksInfo: CastAudioTracksDict = {}
  for (let i = 1; i <= countStrict; ++i) {
    const label = `${TRACK_PREFIX_CASTER}${i}` as MixerTrackLabel
    tracksInfo[label] = { name: `${i - 1}`, order: i }
  }
  return tracksInfo
}

export const getOrderedCastAudioTracks = (cast: HasAudioTracks): MixerTrackLabel[] => {
  const audioTracks = cast.audioTracks || {}
  const labels = Object.keys(audioTracks) as MixerTrackLabel[]
  labels.sort((labelA, labelB) => {
    const orderA = audioTracks[labelA as MixerTrackLabel]?.order
    const orderB = audioTracks[labelB as MixerTrackLabel]?.order
    if (orderA === undefined || orderB === undefined) return 0
    if (orderA < orderB) return -1
    if (orderA > orderB) return 1
    return 0
  })
  return labels
}

export const getAudioTracksOfUser = (userId: string, cast: Cast|null) => {
  if (cast === null) return null
  const audioTracks: number[] = []
  const casterAudioTracks = cast.invited_casters?.[userId].audioTracks ?? {}
  if (cast.castType === CastType.Switcher && Object.keys(casterAudioTracks).length === 0) return null
  for (const label of Object.keys(casterAudioTracks)) {
    const mixerTrackId = LABEL_TO_MIXER_TRACK_MAP[label as defaultMixerTrackLabel]
    if (mixerTrackId !== undefined) {
      audioTracks.push(mixerTrackId)
    }
  }
  return audioTracks
}
